import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

import './QuoteHero.css';

import {
  PageSection,
  Container,
  ContentContainer,
  Quote,
  Footnote,
} from './QuoteHero.css.js';

const QuoteHero = ({ config, content }) => {
  const { backgroundColor, sectionVerticalPaddingSize } = config;
  const { quote, footnote, footnoteImage } = content;

  return (
    <PageSection
      backgroundColor={backgroundColor}
    >
      <Container
        removeGutters={true}
        sectionVerticalPaddingSize={sectionVerticalPaddingSize}
      >
        <ContentContainer>
          <Quote><ReactMarkdown escapeHtml={false}>{quote}</ReactMarkdown></Quote>
          <Footnote><ReactMarkdown escapeHtml={false}>{footnote}</ReactMarkdown></Footnote>
        </ContentContainer>
      </Container>
    </PageSection>
  );
}

QuoteHero.propTypes = {
  config: PropTypes.shape({
    backgroundColor: PropTypes.string,
    sectionVerticalPaddingSize: PropTypes.oneOf([`x-large`, `large`, `medium`, `small`, `none`]),
  }),
  content: PropTypes.shape({
    quote: PropTypes.string.isRequired,
    footnote: PropTypes.string.isRequired,
    footnoteImage: PropTypes.string,
  }),
}

export default QuoteHero;
